/*
  **************************************************************************
    sidebar js
  **************************************************************************
*/

$(function() {
    $('#sidebar').on('click', '[slot="title"]', function() {
        $('.sidebar-menu [slot="title"], .sidebar-menu [slot="group-title"], .group li a').removeClass('active');
        $(this).addClass('active');
        $('.sidebar-menu .group').hide();
        $(this).next('.group').show();
    });

    $('#sidebar').on('click', '[slot="group-title"]', function() {
        $('.sidebar-menu [slot="group-title"]').removeClass('active');
        $(this).addClass('active');
        $('[slot="group-title"] .arrow').removeClass('active');
        $(this).children('.arrow').addClass('active');
        $('.sidebar-menu .group').hide();
        $(this).next('.group').show();
    });

    $('#sidebar').on('click', '.group li a', function() {
        $('.sidebar-menu [slot="title"]').removeClass('active');
        $('.group li a').removeClass('active');
        $(this).addClass('active');
    });
});



// WEBPACK FOOTER //
// ./src/assets/js/sidebar.js